import { useEffect, useRef } from "react";
import { APIProvider, useMapsLibrary } from "@vis.gl/react-google-maps";

function extractCity(place) {
  const comps = place.address_components || [];
  const pick = (t) => comps.find((c) => c.types.includes(t))?.long_text;
  return pick("locality") || pick("postal_town") || pick("administrative_area_level_2") || "";
}

function AutocompleteInput({ onPlaceSelect, inputRef, ...props }) {
  const places = useMapsLibrary("places");
  const localRef = useRef(null);
  const ref = inputRef || localRef;

  useEffect(() => {
    if (!places || !ref.current) return undefined;
    const ac = new places.Autocomplete(ref.current, {
      fields: ["formatted_address", "geometry", "address_components"],
    });
    const listener = ac.addListener("place_changed", () => {
      const place = ac.getPlace();
      if (!place?.formatted_address) return;
      const loc = place.geometry?.location;
      onPlaceSelect?.({
        address: place.formatted_address,
        city: extractCity(place),
        lat: loc ? loc.lat() : null,
        lng: loc ? loc.lng() : null,
      });
    });
    return () => listener.remove();
  }, [places]);

  return <input ref={ref} {...props} />;
}

export default function AddressAutocomplete(props) {
  const key = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;
  if (!key) {
    const { onPlaceSelect, ...rest } = props;
    return <input {...rest} />;
  }
  return (
    <APIProvider apiKey={key}>
      <AutocompleteInput {...props} />
    </APIProvider>
  );
}
